<template>
    <multiselect
        :value="value" 
        track-by="id" 
        :custom-label="fullNameLabel" 
        @input="$emit('input', $event)" 
        :options="selectOptions"
        :searchable="true" 
        :loading="isLoading"
        :show-labels="false"
        :internal-search="false" 
        :close-on-select="true" 
        :preserveSearch="true" 
        :options-limit="300"
        :max-height="600" 
        :show-no-results="false" 
        :hide-selected="false" 
        @search-change="asyncFind"
        :preselect-first="true"
        :allow-empty="false"
    >
        <template slot="clear" slot-scope="props">
            <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
        </template>
    </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect"
import axios from "axios"

export default {
    components: {
        Multiselect,
    },
    props: {
        value: Object,
    },
    data() {
        return {
            isLoading: false,
            options: [],
        }
    },
    methods: {
        asyncFind (query) {
            if (!query) {
                return;
            }

            this.isLoading = true
            axios.get(route('attendee-import-contacts.index'), {
                params: {
                    search: query,
                }
            })
            .then((response) => {
                console.log(response.data)
                this.options = response.data
            })
            .finally(() => {
                this.isLoading = false
            })
        },
        fullNameLabel ({id, unique_id, given_name, surname, label}) {
            return `${given_name} ${surname} [${unique_id}]`
        }
    },
    computed: {
        selectOptions() {
            return [
                ...this.options,
                {'id': null, 'given_name': '', 'surname': '', 'unique_id': 'Create a new contact'},
            ]
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>